
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.318 19.822"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M16.838 11.197s1.087-10.7-6.632-10.7-6.548 10.7-6.548 10.7l-3.159 3.6h19.318zM14.785 14.839a4.483 4.483 0 01-4.484 4.483 4.483 4.483 0 01-4.483-4.483"}})])])
          )
        }
      }
    